import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { number, string, nullValidation } from "@altostra/type-validations/lib/primitives";

import type {
  DecisioningStudioLiftDecompositionResult,
  DecisioningStudioLiftDecompositionState,
  DecisioningStudioLiftDecompositionWarning,
} from "./types";

const isState = enumOf<DecisioningStudioLiftDecompositionState>(
  "ok",
  "single_dimension",
  "pending",
  "stale",
  "hidden",
  "config_error",
  "unknown_error"
);

const isWarning = enumOf<DecisioningStudioLiftDecompositionWarning>("missing_optimization_split");

export const isDecisioningStudioLiftDecompositionResult = objectOf<DecisioningStudioLiftDecompositionResult>({
  state: isState,
  reason: anyOf(string, nullValidation),
  report_dt: anyOf(string, nullValidation),
  updated_ts: anyOf(string, nullValidation),
  failing_since: anyOf(string, nullValidation),
  dimensions: arrayOf(
    objectOf({
      dimension: string,
      name: string,
      normalized_uplift_share: number,
      optimization_share: anyOf(number, nullValidation),
    })
  ),
  warnings: arrayOf(isWarning),
});
